var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.therapist_id > 0)?_c('QuickBreaks',{attrs:{"therapistID":_vm.therapist_id}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }